import {LicenseInfo} from '@mui/x-license';

/**
 * This license is NOT a secret, so we allow it hardcoded
 * @see https://mui.com/x/introduction/licensing/#license-key
 */
export const configureMuiPro = () => {
  LicenseInfo.setLicenseKey(
    '276d837c19018f257606b102f47ae45fTz0xMjk2MTAsRT0xODExNDYyMzk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMS0yMDI2LFE9MixBVD1tdWx0aSxLVj0y',
  );
};
